import * as BABYLON from "babylonjs";
import config from "../config";
import { copymesh, worldToScreen } from "../Tools/index.js";
export class Equipment {
  constructor(type) {
    // mesh.$type 'powerBox'
    // mesh.id 'powerBox8'
    // mesh.scaling
    // mesh.position
    // mesh.getBoundingInfo().boundingSphere.centerWorld
    // this.id =
    this.type =  type
    this.cfg = config[type]
  }
  show(mesh){
    this.lastmesh = mesh
    this.centerWorld = mesh.getBoundingInfo().boundingSphere.centerWorld
    levelsShowIns.activeIn = this
    levelsShowIns.activeOut = mesh.id
    levelsShowIns.scene.registerBeforeRender(this.addHotPoi);
  }
  addHotPoi() {
    try {
      
    
    let cw = levelsShowIns.activeIn.centerWorld
    let cfg = levelsShowIns.activeIn.cfg
    let pois = cfg.hotpoi
    // hotpoi: [
    //   {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
    //   {name:'PCS', isBattery:false,x: 0.3, y: 0, z: 2.4383 * scal/2},
    //   {name:'空调',isBattery:false,x: 0.2, y: 0, z: 2.4383 * scal/2},
    //   // {name:'储能电池',isBattery:1,x: 0.1, y: 0, z: 2.4383 * scal/2},
    // ]
    for (let index = 0; index < pois.length; index++) {
      let poi = pois[index];
      let hotpoi = [cw._x + poi.x,cw._y + poi.y,cw._z + poi.z,]
      let point = new BABYLON.Vector3(...hotpoi);
      let res = worldToScreen(
        point,
        levelsShowIns.camera,
        levelsShowIns.scene,
        levelsShowIns.engine
      );
      poi.show = res._z < 1 ? true : false;
      poi.s = res._z;
      poi.left = res._x;
      poi.top = res._y;
    }

    levelsShowIns.eventbus.$emit('inpois', pois);
  } catch (error) {
      
  }
  }
  hide() {
    levelsShowIns.scene.unregisterBeforeRender(this.addHotPoi);
    this.lastmesh.isPickable = true
    this.lastmesh = null
  }
}


// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/Equipment.js